import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzNpday65 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_NPDAY_65: Record<
  Exclude<PageIdWoofzNpday65, PageIdWoofzNpday65.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SUBSCRIPTIONS_NPDAY_65]: {
    id: PageId.SUBSCRIPTIONS_NPDAY_65,
    hasHeader: false,
  },
  [PageId.CHAT_UPSELL_NPDAY_65]: {
    id: PageId.CHAT_UPSELL_NPDAY_65,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_NPDAY_65]: {
    id: PageId.UPSELL_NPDAY_65,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_NPDAY_65]: {
    id: PageId.DOWNLOAD_NPDAY_65,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
